export default {
  data: () => ({
    isAssignRelationLoaded: false,
    isAssignRelationVisible: false,
  }),
  computed: {
    relationAssignmentButton() {
      return {
        name: 'relationAssignmentButton',
        icon: 'mdi-transit-connection-horizontal',
        tooltip: this.isAnyFeatureSelected
          ? this.$i18n.t('button.assignRelation')
          : this.$i18n.t('button.toAssignRelation', {
              suffix: this.$i18n.t('button.atLeastOneSelected'),
            }),
        fontSize: '19px',
        disabled: !this.isAnyFeatureSelected,
      };
    },
  },
  methods: {
    relationAssignmentButtonAction() {
      this.isAssignRelationLoaded = this.isAssignRelationVisible = true;
    },
  },
};
